import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
// import tableVodCatalog from './tableVodTemplateCatalog';
import IngestServersFields from './formGroup20ServersFields';

export default {
  title: 'Video Codecs',
  attributeName: 'videoCodecs',
  // visibleWhen:{"field":"deploymentType","value":'ott'},
  fields: [
    {
      attributeName: 'globalVideoCodec',
      type: FormInputTypes.SELECT,
      label: 'Global Video Codec',
      options: [
        { name: 'hevc_nvenc', value: 'hevc_nvenc' },
        { name: 'h264_nvenc', value: 'h264_nvenc' },
        { name: 'av1_nvenc', value: 'av1_nvenc' },
      ],
      helpText: 'Set a global videocodec for all the cameras.',
      errorText: '',
      // visibleWhen:[{"field":"deploymentType","value":'ott'}],
    },
    
  ]
};
